import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ImmomioIconName } from '../../models';

@Directive()
export abstract class ButtonBaseComponent {
  @Input() text?: string;
  @Input() className?: string;
  @Input() isEnabled? = true;
  @Output() tapped?: EventEmitter<boolean> = new EventEmitter();
  @Input() iconName?: ImmomioIconName;
  @Input() size?: number;
}
